import { useMemo } from 'react';
import { Differ, Viewer } from 'json-diff-kit';
import 'json-diff-kit/dist/viewer.css';

interface DiffJsonViewerProps {
  baseData: any;
  baseDataTitle: string;
  compareData: any;
  compareDataTitle: string;
}

const differ = new Differ({
  detectCircular: true,
  maxDepth: Infinity,
  showModifications: true,
  arrayDiffMethod: 'lcs',
});

const DiffJsonViewer = ({
  baseDataTitle,
  baseData,
  compareDataTitle,
  compareData,
}: DiffJsonViewerProps) => {
  const differences = useMemo(() => differ.diff(baseData, compareData), [baseData, compareData]);
  return (
    <div className="flex flex-1 flex-col overflow-hidden rounded">
      <div className="mb-2 flex justify-between">
        <h4 className="text-sm font-semibold text-gray-700">{baseDataTitle}</h4>
        <h4 className="text-sm font-semibold text-gray-700">{compareDataTitle}</h4>
      </div>

      <div className="flex-1 overflow-auto rounded bg-white bg-white p-2 text-black [&_*]:!text-black [&_*]:text-black">
        <Viewer
          diff={differences}
          lineNumbers={true}
          highlightInlineDiff={true}
        />
      </div>
    </div>
  );
};

export default DiffJsonViewer;
